import { useState } from 'react'
import quotesData from '@/data/quotes.json'
import { hexContrast, randomHex } from '@/lib/color'

interface Quote {
  quote: string
  author: string
}

const quotes = quotesData.quotes as Quote[]

function pick(): { q: Quote; hex: string } {
  return { q: quotes[Math.floor(Math.random() * quotes.length)], hex: randomHex() }
}

/**
 * A random quote about color on a
 * random color. Click it for another.
 */
export default function QuoteCard({ className = '' }: { className?: string }) {
  const [state, setState] = useState(pick)
  const color = hexContrast(state.hex)

  return (
    <button
      type="button"
      onClick={() => setState(pick())}
      title="Click for another quote"
      className={`flex w-full flex-col items-center justify-center px-6 py-10 text-center font-display transition-colors duration-500 ${className}`}
      style={{ backgroundColor: state.hex, color, minHeight: 175 }}
    >
      <span className="font-medium" style={{ fontSize: 'calc(1.4vw + 1.1rem)', lineHeight: 1.25 }}>
        <span className="font-serif">&#8220;</span>
        {state.q.quote}
        <span className="font-serif">&#8221;</span>
      </span>
      <span className="mt-3 font-semibold italic" style={{ fontSize: 'calc(1vw + 0.9rem)' }}>
        - {state.q.author}
      </span>
    </button>
  )
}
